/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import ContentArea from '../../ContentArea';
import Content from '../../ContentArea/Content';

const EmptyNavigation = ({ text }) => (
  <ContentArea>
    <Content empty>
      <p className="tc ttu white">{text}</p>
    </Content>
  </ContentArea>
);

EmptyNavigation.propTypes = {
  text: PropTypes.string,
};

export default EmptyNavigation;



// WEBPACK FOOTER //
// ./src/components/common/EmptyState/Navigation.jsx